<template>
    <div class=slideshow-page>

        <Slideshow v-if="loaded" :slides="slides || wpSlides" :settings="slideshowSettings" :hasPopup="true"></Slideshow>

        <PageDescription :post="post" />

    </div>
</template>
<script>
import Slideshow       from '../components/Slideshow.vue'
import PageDescription from '../components/PageDescription.vue'

export default {
    name : 'SlideshowPage',
    props : {
        slides            : Array ,
        slideshowSettings : Object,
        post              : Object,
    },
    data() {
        return {
            wpSlides  : [],
            loaded : false,
        }
    },
    components : {
        Slideshow,
        PageDescription,
    },
    methods : {
        init() {

        }
    },
    computed : {
        slideShowProps() {
            return {};
        }
    },
    created() {
        for( let slide of this.post.acf.slides ) {
            this.wpSlides.push({
                image : slide.image.sizes.large ,
                title : slide.text              ,
            });
        }

        this.loaded = true;
    },
    mounted() {
        this.init();
    }
}
</script>